/**
 * Room for the " (Admin Name)" the API appends: the stored comment is read back through
 * VARCHAR(255) by the driver screens, and the API rejects anything that would not fit.
 */
export const MAX_DESCRIPTION_LENGTH = 200;

interface NamedDriver {
	driverId: number;
	firstName?: string | null;
	lastName?: string | null;
}

/** "First Last", or "#id" when the API has no name (an id that is not a driver). */
export const driverFullName = (driver: NamedDriver) => {
	const name = `${driver.firstName ?? ""} ${driver.lastName ?? ""}`.trim();
	return name || `#${driver.driverId}`;
};

/** Sums decimal amounts without the float drift of adding cents one by one. */
export const sumAmounts = (amounts: number[]) =>
	Math.round(amounts.reduce((sum, amount) => sum + amount * 100, 0)) / 100;

/** Fills "{name}" placeholders in a translated template. */
export const fillTemplate = (
	template: string,
	values: Record<string, string | number>
) =>
	Object.entries(values).reduce(
		(text, [key, value]) => text.split(`{${key}}`).join(String(value)),
		template
	);
